/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiInformationV1Dto } from '../models/ApiInformationV1Dto';
import type { ApiVersionInformationV1Dto } from '../models/ApiVersionInformationV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApiInformationService {
  /**
   * @returns ApiInformationV1Dto
   * @throws ApiError
   */
  public static apiInformationControllerV1GetApiInformationV1(): CancelablePromise<ApiInformationV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/api-information',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ApiVersionInformationV1Dto
   * @throws ApiError
   */
  public static apiInformationControllerV1GetVersionV1(): CancelablePromise<ApiVersionInformationV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/api-information/version',
    });
  }
}
